import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { aboutValues, brandTagline } from "@/mocks/siteData";

export default function AboutPreview() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-primary-900">
      <div className="max-w-content mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
        <div className="lg:col-span-5">
          <Reveal>
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-accent-300">
              <span className="w-6 h-px bg-accent-400"></span>
              关于潜声
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
              一个把「{brandTagline}」当作底线的投稿平台
            </h2>
            <p className="mt-5 text-[15px] leading-relaxed text-background-200">
              潜声投稿不做流量生意，只做一件事：让掌握线索的人，能在一个相对安全的环境里把信息交出去。
              我们相信，只有当投稿者不必担心后果，线索才有可能被完整地讲述出来。
            </p>
            <p className="mt-4 text-[15px] leading-relaxed text-background-300/90">
              平台由内容编辑与事实核查人员共同维护，所有线索统一登记、统一脱敏、统一核实，不因线索来源不同而区别对待。
            </p>
            <Link
              to="/about"
              className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-50/25 text-background-50 font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解我们的定位与原则
              <i className="ri-arrow-right-line"></i>
            </Link>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {aboutValues.map((value, index) => (
              <Reveal key={value.id} delay={index * 80}>
                <div className="h-full p-6 rounded-lg bg-background-50/5 border border-background-50/12">
                  <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-500/15 text-accent-300 text-xl">
                    <i className={value.icon}></i>
                  </span>
                  <h3 className="mt-5 font-heading text-lg font-bold text-background-50">
                    {value.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-background-300/90">{value.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}